import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isoToDate' })
export class IsoToDatePipe implements PipeTransform {
  transform(isoString: string): Date {
    return new Date(isoString);
  }
}
